// extracted by mini-css-extract-plugin
module.exports = {"btn":"BtnArriba__btn__3ZYLv","btn-desaparece":"BtnArriba__btn-desaparece__3DM9Y","icono":"BtnArriba__icono__FwBks"};